import { IHostResponse, IHostStatus } from './interfaces';

export const getLabels = (
  host?: IHostResponse['hostOverview']
): Array<IHostStatus> => {
  if (!host) return [];

  const { in_service, online, client_sessions, bookings } = host;

  const result: Array<IHostStatus> = [];

  if (in_service) {
    result.push({ locale: 'host.statuses.service', color: 'orange' });
  }

  if (client_sessions.length) {
    result.push({ locale: 'host.statuses.busy', color: 'blue' });

    if (!online) {
      result.push({
        locale: 'host.statuses.noConnection',
        color: 'red',
      });
    }
  } else if (online) {
    result.push({ locale: 'host.statuses.on', color: 'green' });
  } else if (!online) {
    result.push({ locale: 'host.statuses.off', color: 'gray-primary' });
  }

  if (bookings.length) {
    result.push({ locale: 'host.statuses.booked', color: 'blue' });
  }

  return result;
};
